import { Routes } from '@angular/router';
import { LandingPage } from './features/landing/landing.page';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: "full"
  },

  // {
  //   path: 'landing',
  //   component: LandingPage

  // },

  {
    path: 'login',
    loadChildren: () => import('./features/firebase-auth/firebase-auth.routes').then((m) => m.LOGIN_ROUTES)
  },

  
];
